/**
 * Determines whether the current surface uses the nudge recommendation pipeline.
 *
 * Surfaces that return `true` will trigger a call to the `/proactive` API to fetch
 * nudge recommendations — which handles eligibility checking, content generation,
 * and ranking of registered nudges.
 *
 * Surfaces that return `false` bypass the recommendation pipeline entirely and
 * display registered nudges directly based on consumer-defined eligibility.
 */
export const isNudgeRecommendationSurface = ({
	product,
	pageUrl,
	isLiveDoc,
}: {
	isLiveDoc?: boolean;
	pageUrl: string;
	product: string;
}): boolean => {
	if (product !== 'confluence') {
		return false;
	}
	if (pageUrl.includes('/wiki/search')) {
		return false;
	}
	if (isLiveDoc) {
		return false;
	}
	return true;
};
